import { requestZeusFromBrowser } from 'components/api/zeusBrowserClient';

import { GetMarketplacePropertySellerDisclosuresDocument } from './__generated__/seller-disclosures.zeus';

type SellerDisclosureDownload = { status: 'available'; url: string } | { status: 'unavailable' };

export const getSellerDisclosureDownload = async (
  addressId: string,
): Promise<SellerDisclosureDownload> => {
  const data = await requestZeusFromBrowser(GetMarketplacePropertySellerDisclosuresDocument, {
    addressId,
  });
  const url = data.marketplace.sellerDisclosuresDownloadUrl;
  return url ? { status: 'available', url } : { status: 'unavailable' };
};
